<template>
  <b-form-group
    label="Proje"
    label-for="id_projects"
  >
    <validation-provider
      #default="{ errors }"
      name="Proje"
      rules="required"
    >
      <v-select
        id="id_projects"
        v-model="dataItem.id_projects"
        label="title"
        :options="projects"
        :reduce="project => project.id"
        placeholder="Seçiniz"
        :disabled="dataItem.id > 0"
        :clearable="false"
        @input="getProjectPackages"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'LicenceProject',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['licenses/dataItem']
    },
    projects() {
      return this.$store.getters['projects/dataList']
    },
  },
  created() {
    localize(this.locale)
    this.getProjects()
  },
  methods: {
    getProjects() {
      this.$store.dispatch('projects/getDataList', {
        select: [
          'projects.id AS id',
          'projects.title AS title',
        ],
        where: {
          'projects.status': 1,
        },
      })
    },
    getProjectPackages() {
      this.dataItem.id_project_packages = null
      this.$store.dispatch('projectPackages/getDataList', {
        select: [
          'project_packages.id AS id',
          'project_packages.title AS title',
        ],
        where: {
          'project_packages.id_projects': this.dataItem.id_projects,
        },
      })
    },
  },
}
</script>

<style scoped></style>
